import React from "react";

import { InputStyles } from "./styles.module";
// import InputMask from "react-input-mask";

interface IInputProps {
  classWrapper?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  maxlength?: number;
  value?: string;
  type?: string;
  fieldRef?(ref: any): void;

  masked?: boolean;
  mask?: string;

  onChange?(e: any): void;
  onClick?(e: any): void;
}

interface IInputState {
  value: string;
}

export class Input extends React.Component<IInputProps, IInputState> {
  constructor(props: IInputProps) {
    super(props);

    this.state = {
      value: props.value ? props.value : "",
    } as IInputState;
  }

  componentDidUpdate(prevProps: IInputProps) {
    if (prevProps.value !== this.props.value) {
      let v = this.props.value ? this.props.value : "";
      this.setState({ value: v });
    }
  }

  onChangeInput(e: any) {
    this.setState({
      value: e.target.value,
    });
    this.props.onChange && this.props.onChange(e);
  }

  defaultInput() {
    return (
      <input
        type={this.props.type || "text"}
        placeholder={this.props.placeholder || ""}
        className={`input ${this.props.className ? this.props.className : ""}`}
        disabled={!!this.props.disabled}
        maxLength={this.props.maxlength}
        value={this.state.value || ""}
        onChange={this.onChangeInput.bind(this)}
        onClick={(e: any) => this.props.onClick && this.props.onClick(e)}
        ref={(ref: any) => this.props.fieldRef && this.props.fieldRef(ref)}
      />
    );
  }

  /*
  maskedInput() {
    // "(999) 999-9999"
    return (
      <InputMask
        type={this.props.type || "text"}
        disabled={!!this.props.disabled}
        placeholder={this.props.placeholder || ""}
        maxLength={this.props.maxlength}
        mask={this.props.mask || ""}
        className={`input ${this.props.className ? this.props.className : ""}`}
        autoComplete="new-password"
        value={this.state.value || ""}
        onChange={this.onChangeInput.bind(this)}
        onClick={(e: any) => this.props.onClick && this.props.onClick(e)}
        ref={(ref: any) => this.props.fieldRef && this.props.fieldRef(ref)}
      />
    );
  }
  */

  render() {
    // ? this.maskedInput.call(this)

    return (
      <InputStyles
        className={`${this.props.classWrapper ? this.props.classWrapper : ""}`}
      >
        {this.props.masked
          ? this.defaultInput.call(this)
          : this.defaultInput.call(this)}
      </InputStyles>
    );
  }
}
